import { h as r } from "vue";
const n = (e) => r("div", {}, [r("span", {}, [e.label])]);
export {
  n as renderGroupLabel
};
